import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";
import { ElementClickAction } from "../../lib/TrackingAdapter";

interface TeamInvitationSuccess {
  teamName: string;
}

const TeamInvitationSuccess: React.FC<TeamInvitationSuccess> = ({ teamName }) => {
  const navigation = useNavigation();
  const tracker = useTracker();
  const { t, m } = useTranslation();

  return (
    <InfoPage
      variant="success"
      title={t(m.SignUp.SuccessfullyJoinedTeam, { teamName })}
      description={t(m.SignUp.OpenShapr3DDescription)}
      primaryCTA={
        <Button
          onClick={() => {
            tracker.trackButtonClick({
              action: ElementClickAction.GO_TO_DOWNLOAD,
            });
            navigation.goToDownloadPage();
          }}
        >
          {t(m.SignUp.DownloadShapr3D)}
        </Button>
      }
    />
  );
};

export default TeamInvitationSuccess;
